export const API_BASE_URL = 'https://api.dashboard.e-coye.com/api'
